import { AUDIOBOOK, BOOK } from '../search-best-match/search-best-match'

export const BESTSELLER_AUDIO_IDS = {
  ru: 'audio_ru_main',
  en: 'bestsellers',
  hr: 'konacno-u-regiji-audio-knjige',
  da: 'audio_da_bestsellers',
  de: 'belletristik',
  es: 'solo-en-bookmate',
  sr: 'konacno-u-regionu-audio-knjige',
  sv: 'bastsaljare',
  tr: 's-tr-sesli-kitaplar',
  uk: 'populiarne',
  bg: 'audioknigi-proza',
  hu: 'pick-s-a-het',
}

export const GHANA_TEXTS = {
  code_description:
    'Get access to a huge catalog of books available by subscription via iOS or Android app',
  code_faq_1_desc:
    'A promo code is a special offer provided by Bookmate to its new or existing customers. Depending on the promotion type, this offer may include a free period of Premium subscription usage, discounted subscription price or other goodies. Offers typically have a limited duration, so make sure to grab them when it’s still possible! <br /> <br /> The promo code - and its offer - is applied at the same time as you activate it. After the time specified in the offer passes, you’ll no longer be able to use the service on the same conditions - for example, if the discounted price is for 3 months, then after these 3 months pass, you can continue using the service for the standard price in your country.',
  code_faq_2_desc:
    'Sure! You’ll be prompted to create a new account during the process of promo code activation.',
  code_faq_3_desc:
    'Depends on the exact conditions of the offer. Some of the offers apply to existing subscribers, so make sure to check emails from Bookmate and browse through notifications from time to time!',
  code_faq_4_desc:
    'When you sign up for a subscription, you choose a subscription plan, provide your payment information and agree to the terms and conditions of the subscription service during this process.<br /><br /> At the predetermined interval (e.g., monthly or annually), we’ll charge your payment method for the subscription amount. Please note that you don’t need to take any action for each billing cycle unless you want to modify or cancel your subscription.<br /> <br /> If you don’t cancel the subscription or modify your plan, the recurring payments continue to be charged at the agreed-upon intervals, providing continuous access to the subscribed services, but you always have the options to manage your subscription, such as upgrading or downgrading plans, changing payment methods, or canceling the subscription.',
  code_faq_5_desc:
    "All the added books, as well as your quotes and impressions will remain where they are, but you won't be able to read or listen to them until you pay for the subscription again. Naturally, free books and podcasts will be available even when you don’t have an active subscription or a promo code offer activated. <br /><br /> * Bookmate needs your payment information only in cases where the terms and conditions of the promo offer imply that you'll be paying for your future subscription at a certain moment (e.g. when the trial period ends).",
}

export const DATA = {
  en: [
    {
      bookTitle: 'Ghost House',
      bookUuid: 'qwP9Vns0',
      bookAuthor: 'Sara Connell',
      bookAuthorUuid: 'BDAJ7xY0',
      type: AUDIOBOOK,
    },
    {
      bookTitle: 'In the Distance',
      bookUuid: 'OyCfdZEI',
      bookAuthor: 'Hernan Diaz',
      bookAuthorUuid: 'KegBoqNy',
      type: BOOK,
    },
    {
      bookTitle: 'NK3',
      bookUuid: 'S4CtARAL',
      bookAuthor: 'Michael Tolkin',
      bookAuthorUuid: 'k64k3OIW',
      type: BOOK,
    },
    {
      bookTitle: 'Be Unexpected',
      bookUuid: 'WN8gbFVu',
      bookAuthor: 'Marva Bailer',
      bookAuthorUuid: 'taFsHyAo',
      type: AUDIOBOOK,
    },
  ],
  sr: [
    {
      bookTitle: 'Клуб 5',
      bookUuid: 'XRqhicrv',
      bookAuthor: 'Ивана Нешић',
      bookAuthorUuid: 'Y8f87y4g',
      type: AUDIOBOOK,
    },
    {
      bookTitle: 'Iz svoje kože',
      bookUuid: 'NtWcoOUI',
      bookAuthor: 'Aleksandar Stanković',
      bookAuthorUuid: 'mqlIhK1x',
      type: BOOK,
    },
    {
      bookTitle: 'Ono što ne možemo reći',
      bookUuid: 'GkLcw2V5',
      bookAuthor: 'Keli Rimer',
      bookAuthorUuid: 'QU1CZJoU',
      type: BOOK,
    },
    {
      bookTitle: 'Pas',
      bookUuid: 'CqGkWkNv',
      bookAuthor: 'Ivan Tokin',
      bookAuthorUuid: 'sLRw17RF',
      type: AUDIOBOOK,
    },
  ],
  hr: [
    {
      bookTitle: 'Senke Grimizne šume',
      bookUuid: 'pLrP1TuP',
      bookAuthor: 'Drina Štajnberg',
      bookAuthorUuid: 'bqFEXq8O',
      type: AUDIOBOOK,
    },
    {
      bookTitle: 'Progutana',
      bookUuid: 'z9RBRx0T',
      bookAuthor: 'J.R. Ward',
      bookAuthorUuid: 'dM2mnq1w',
      type: BOOK,
    },
    {
      bookTitle: 'Noćni tigar',
      bookUuid: 'RlukiohS',
      bookAuthor: 'Yangsze Choo',
      bookAuthorUuid: 'ZBEwZcv8',
      type: BOOK,
    },
    {
      bookTitle: 'Nigdje niotkuda',
      bookUuid: 'lvTkLlHH',
      bookAuthor: 'Bekim Sejranović',
      bookAuthorUuid: 'PYftRK0q',
      type: AUDIOBOOK,
    },
  ],
  es: [
    {
      bookTitle: 'Fruto',
      bookUuid: 'uo5JZdXu',
      bookAuthor: 'Daniela Rea Gómez',
      bookAuthorUuid: 'dG5dVh70',
      type: AUDIOBOOK,
    },
    {
      bookTitle: 'Camina',
      bookUuid: 'gpKAInDy',
      bookAuthor: 'DeLana Libby',
      bookAuthorUuid: 'BbeB4txk',
      type: BOOK,
    },
    {
      bookTitle: 'El viento entre los pinos',
      bookUuid: 'Q2tVmJg7',
      bookAuthor: 'Malena Higashi',
      bookAuthorUuid: 'hIHp7G9g',
      type: BOOK,
    },
    {
      bookTitle: 'Comunión',
      bookUuid: 'gdm7oRZu',
      bookAuthor: 'Bell Hooks',
      bookAuthorUuid: 'wopo8asW',
      type: AUDIOBOOK,
    },
  ],
  bg: [
    {
      bookTitle: 'Земляци',
      bookUuid: 'iDd4UOu0',
      bookAuthor: 'Йордан Йовков',
      bookAuthorUuid: 'wavOnsZq',
      type: AUDIOBOOK,
    },
    {
      bookTitle: 'По здрач',
      bookUuid: 'bKxDYyXO',
      bookAuthor: 'Антони Делон',
      bookAuthorUuid: 'zwO7eegg',
      type: BOOK,
    },
    {
      bookTitle: 'Нощен влак за Лисабон',
      bookUuid: 'TudW7DyA',
      bookAuthor: 'Паскал Мерсие',
      bookAuthorUuid: 'ORHkgdAz',
      type: BOOK,
    },
    {
      bookTitle: 'The Love Compass',
      bookUuid: 'HftY1xAF',
      bookAuthor: 'Stefani Seek',
      bookAuthorUuid: 'CxTNzbDI',
      type: AUDIOBOOK,
    },
  ],
  da: [
    {
      bookTitle: 'Vindueskiggeren',
      bookUuid: 'cXdjS3iP',
      bookAuthor: 'Erling Jepsen',
      bookAuthorUuid: 'wVoPSnAp',
      type: AUDIOBOOK,
    },
    {
      bookTitle: 'Andre tider',
      bookUuid: 'yrz3HXWZ',
      bookAuthor: 'Ali Smith',
      bookAuthorUuid: 'IT4RSBuc',
      type: BOOK,
    },
    {
      bookTitle: 'Jordisk',
      bookUuid: 'YuFAqPvw',
      bookAuthor: 'Theis Ørntoft',
      bookAuthorUuid: 'sZUhgtqh',
      type: BOOK,
    },
    {
      bookTitle: 'Der bor en ung pige i mig, som ikke vil dø',
      bookUuid: 'FNlykg4X',
      bookAuthor: 'Tove Ditlevsen',
      bookAuthorUuid: 'DzVmQyob',
      type: AUDIOBOOK,
    },
  ],
}
